
<template>
  <div>
    <!-- <PageLoader v-bind:storage="appLoading" /> -->
    <ServerError v-if="ServerError" />
    <v-layout wrap justify-center py-2 v-if="reviews" pa-3 class="cblack">
      <!-- <v-flex xs12> <v-divider></v-divider> </v-flex> -->
      <v-flex xs12 py-2 px-xl-6 align-self-center text-left>
        <span class="ibmbold ">REVIEWS</span>
      </v-flex>
      <v-flex xs12 v-if="reviews.length > 0">
        <v-layout wrap>
          <v-flex xs12 py-2 v-for="(item, i) in reviews" :key="i">
            <v-layout wrap v-if="item.uid.customerid">
              <v-flex xs2 sm1 lg1 align-self-start v-if="item.uid.customerid">
                <v-avatar>
                  <img
                    :src="mediaURL + item.uid.customerid.photo"
                    :alt="item.uid.customerid.firstName"
                  />
                </v-avatar>
              </v-flex>
              <v-flex
                xs11
                lg11
                xl10
                align-self-start
                text-left
                pr-sm-6
                v-if="item.uid.customerid"
              >
                <span class="popsemibold"
                  >{{ item.uid.customerid.firstName }}
                  {{ item.uid.customerid.lastName }}</span
                >
                <br />
                <span
                  style="
                    font-family: poppinslight;
                    font-size: 14px;
                    color: #707070;
                  "
                >
                  {{ item.review }}
                </span>
                <br />
                <v-layout wrap>
                  <v-flex xs4 sm6 text-left>
                    <span class="popsemibold" style="font-size:12px">RATED</span
                    >&nbsp;
                    <span class="popsemibold">{{ item.rating }}</span>
                    <v-rating
                      v-model="item.rating"
                      color="#FFD341"
                      background-color="#e0e0e0"
                      empty-icon="$ratingFull"
                      half-increments
                      readonly
                      hover
                      small
                    ></v-rating>
                    <span>
                      <!-- <v-icon small color="#FFD341">mdi-star</v-icon> -->
                    </span>
                  </v-flex>
                  <v-flex xs8 sm6 text-right align-self-end>
                    <span class="popregular smallm">
                      <!-- {{ formatDate(item.create_date) }} -->
                      
                    <timeago :datetime="item.create_date"></timeago>
                    </span>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 py-2>
                <v-divider></v-divider>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 v-else>
        0 reviews!
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
 props: ["storage"],
  data() {
    return {
      appLoading: false,
      ServerError: false,
      reviews: {},
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/rating/list",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          ratingType: "seller",
          sellerId:this.storage._id,
          page: 1,
          limit: 7,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.reviews = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      day = day < 10 ? "0" + day : day;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        " " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;
      return strTime;
    },
  },
};
</script>
